module.exports = __webpack_public_path__ + "img/Detect.e2f875f1.png";